// plugins/router-warn-catcher.client.ts
export default defineNuxtPlugin((nuxtApp) => {


return


  const router = useRouter()

  // Keep track of logged paths to prevent duplicate spam in container logs
  const reportedLinks = new Set<string>()

  // Helper function to send log to Nitro server
  const sendToDocker = (targetUrl: string, sourceUrl: string) => {
    const key = `${sourceUrl} -> ${targetUrl}`
    if (reportedLinks.has(key)) return
    reportedLinks.add(key)

    // Send payload via navigator.sendBeacon or $fetch
    const payload = JSON.stringify({
      brokenUrl: decodeURIComponent(targetUrl),
      clickedFrom: decodeURIComponent(sourceUrl),
      timestamp: new Date().toISOString()
    })

    if (navigator.sendBeacon) {
      const blob = new Blob([payload], { type: 'application/json' })
      navigator.sendBeacon('/market/api/log-broken-link', blob)
    } else {
      $fetch('/market/api/log-broken-link', {
        method: 'POST',
        body: JSON.parse(payload)
      }).catch(() => {})
    }
  }

  // 1. Intercept router.resolve (This triggers when <NuxtLink> resolves URLs)
  const originalResolve = router.resolve
  router.resolve = function (to, currentLocation) {
    const resolved = originalResolve.call(this, to, currentLocation)

    // Check if the route failed to match any registered page
    if (!resolved.matched || resolved.matched.length === 0) {
      const currentRoute = router.currentRoute.value.fullPath || window.location.pathname
      const targetPath = typeof to === 'string' 
        ? to 
        : ((to as any)?.path || (to as any)?.fullPath || JSON.stringify(to))

      sendToDocker(targetPath, currentRoute)
    }

    return resolved
  }

  // 2. Intercept router.onError for explicit failed navigations
  router.onError((error, to, from) => {
    if (error?.message?.includes('No match') || (to && (!to.matched || to.matched.length === 0))) {
      sendToDocker(to.fullPath, from.fullPath)
    }
  })
})
